import { useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import {
  EducationInstitutionNameInput,
  EducationInstitutionTypeSelect,
} from '@flex-private-packages/recruiting-common/components';
import { Controller } from 'react-hook-form';

import type { JobDescriptionFormState } from '../../../../models';

interface Props {
  currentIndex: number;
  required: boolean;
}

export function EducationInstitutionNameAndTypeFormItem({
  currentIndex,
  required,
}: Props) {
  const { t } = useTranslation();

  return (
    <Controller<
      JobDescriptionFormState,
      `educationalBackgrounds.${typeof currentIndex}.name`
    >
      name={`educationalBackgrounds.${currentIndex}.name`}
      rules={{
        required: required
          ? t(
              trans(
                'recruiting.educational_background.institution_name.edit.helper.required'
              )
            )
          : false,
      }}
      render={({ field: nameField, fieldState: { error: nameError } }) => (
        <Controller<
          JobDescriptionFormState,
          `educationalBackgrounds.${typeof currentIndex}.institutionType`
        >
          name={`educationalBackgrounds.${currentIndex}.institutionType`}
          rules={{
            required: required
              ? t(
                  trans(
                    'recruiting.educational_background.institution_level.edit.helper.required'
                  )
                )
              : false,
          }}
          render={({
            field: {
              onChange: onEducationInstitutionTypeChange,
              ...educationInstitutionTypeSelectField
            },
            fieldState: { error: educationInstitutionTypeError },
          }) => {
            const errorState =
              nameError || educationInstitutionTypeError ? 'error' : 'default';
            const helperText =
              nameError?.message ?? educationInstitutionTypeError?.message;

            return (
              <EducationInstitutionNameInput
                required={required}
                placeholder={t(
                  trans(
                    'recruiting.educational_background.institution_name.edit.placeholder'
                  )
                )}
                state={errorState}
                helperText={helperText}
                {...nameField}
              >
                <EducationInstitutionTypeSelect
                  onValueChange={onEducationInstitutionTypeChange}
                  {...educationInstitutionTypeSelectField}
                />
              </EducationInstitutionNameInput>
            );
          }}
        />
      )}
    />
  );
}
